import { render, staticRenderFns } from "./BaseSelectCustomer.vue?vue&type=template&id=21599eb2"
import script from "./BaseSelectCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSelectCustomer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports